import React, { useContext, useEffect, useRef, useState } from "react";
import { Context } from "../../../context/Context";
import "./Remote.css";
import EquipmentButtonIcons from "../../../constants/EquipmentButtonIcon";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

const Remote = ({
  equipment_id,
  closeSelectEquipmentRef,
  closeSelectOutputEquipmentRef,
  data,
  setData,
}) => {
  const { equipmentButtons, devices } = useContext(Context);

  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    // setIsLoading(true);
    // AllEquipmentButton({
    //   equipment_id: equipment_id,
    // }).then(({ data }) => {
    //   setButtons(data.equipment_buttons);
    //   setIsLoading(false);
    // });

    setButtons(
      equipmentButtons.filter((eq_btn) => eq_btn.equipment_id == equipment_id)
    );
  }, [equipmentButtons, equipment_id]);

  const handleClickButton = (button, icon) => {
    const device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    setData({
      icon,
      name: button.name,
      data: [
        2,
        5,
        button.data1,
        button.data2,
        button.data3,
        button.data4,
        button.data5,
      ],
      device: device,
    });
    closeSelectEquipmentRef.current.click();
    closeSelectOutputEquipmentRef.current.click();
  };
  const renderButtons = () => {
    return buttons.map((button) => {
      let iconPath = "/assets/img/app-icons/CU.png";
      let iconId = 20;
      if (button.icon) {
        let buttonIcon = EquipmentButtonIcons.find(
          (icon) => icon.id == button.icon
        );
        iconPath = buttonIcon.path;
        iconId = buttonIcon.id;
      }
      return (
        <div
          className="remote"
          onClick={() => handleClickButton(button, iconId)}
        >
          <div className="icon-part">
            <img src={iconPath} alt="" />
          </div>
          <div className="status-part"></div>
          <div className="info-part">
            <p className="text-center p-0 m-0 d-block">{button.name}</p>
            <p className="text-center p-0 m-0" style={{fontSize: '11px'}}>
              S/{devices.find((d) => d.id == button.device_id)?.serial}
            </p>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="card h-100" style={{backgroundColor: 'transparent', boxShadow: 'unset'}}>
      <div
        className="card-header d-flex align-items-center justify-content-between border-bottom p-0 pt-2"
        style={{ zIndex: 1, top: "0" }}
      >
        <h5>{buttons?.[0]?.equipment?.name ?? ""}</h5>
      </div>
      <div className="card-body scrollbar">
        {/* <SimpleBar style={{ maxHeight: "100%", padding: "1.5rem" }}> */}
          <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">{renderButtons()}</div>
        {/* </SimpleBar> */}
      </div>
    </div>
  );
};

export default React.memo(Remote);
